"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
function generateRemovedItem(item, event) {
    item.quantity = Math.abs(event.quantity);
    item.id = event.id;
    return (0, utils_1.updateRemovedOrderItemDetails)(item, event.reason);
}
/**
 * Removes an ORDER ITEM from an order.
 * Can only be done when the order is in IN_PROGRESS or in CREATED status
 * @param event of type OrderPayment
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a;
    let order = prevState;
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    order.orderItems = order.orderItems || [];
    const orderItemIndex = order.orderItems.findIndex(x => x.id === event.orderItemId);
    if (orderItemIndex === -1) {
        return order;
    }
    const orderItem = order.orderItems[orderItemIndex];
    let removeAllQuantity = true;
    if (event.quantity !== undefined) {
        const quantityToRemove = Math.abs(event.quantity);
        if (orderItem.quantity !== quantityToRemove) {
            removeAllQuantity = false;
            const orderItemCopy = (0, utils_1.clone)(orderItem);
            orderItem.quantity = orderItemCopy.quantity - quantityToRemove;
            order.orderItems.push(generateRemovedItem(orderItemCopy, event));
        }
    }
    if (removeAllQuantity) {
        order.orderItems[orderItemIndex] = (0, utils_1.updateRemovedOrderItemDetails)((0, utils_1.clone)(order.orderItems[orderItemIndex]), event.reason);
    }
    if ((_a = orderItem.comboItems) === null || _a === void 0 ? void 0 : _a.length) {
        const comboItems = orderItem.comboItems.map(item => (0, utils_1.updateRemovedOrderItemDetails)((0, utils_1.clone)(item), event.reason));
        order.orderItems[orderItemIndex].comboItems = comboItems;
    }
    order = { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
    return order;
}
exports.default = default_1;
//# sourceMappingURL=removeOrderItem.js.map